<template>
    <div class="">
        <div class="header-panel">
            <div class="container">
        <Breadcrumb 
            :levelTwoText = "'Countries'"
            :levelTwoLink = "'/countries'"
            :levelThreeText = "$titleCase(country_name)"
            :levelThreeLink = "'/countries/United States'"
            :levelFourText = "$titleCase(state)"
        
        />

        <Heading 
            :preheading = "'Bikepacking & Touring in'" 
            :heading = "$titleCase(state)"
            :noSpaceBelow = "true"
            :level="1"
        />
        <TOC v-if="routesByState.length > 0 || routesByState.length > 0"
                :slot1text="'Blogs'"
                :slot1link="'blogs'"
                :slot2text="routesByState.length > 0 ? 'Routes' : ''"
                :slot2link="routesByState.length > 0 ? 'routes' : ''"
                :slot3text="booksByCountry.length > 0 ? 'Books' : ''"
                :slot3link="booksByCountry.length > 0 ? 'books' : ''"
                />
            <div class="spacer" style="height:30px"></div>
        </div>
        </div>

        <!-- <b-collapse class="card" animation="slide" :open="false" v-if="$hasSubregions(country_code)">
            <template #trigger="props">
            <div class="card-header" style="text-align:center" role="button">
                <p class="card-header-title is-centered" style="text-align:center">Filter By {{country_code == "US" ? 'State' : 'Province'}}</p>
             
            </div>
            </template>
            <div class="card-content">
                <RadioFilter 
                    v-on:selection-change="updateSelectedSubregion"
                    :options = "subregions"
                    :type = "'State / Province'"
                    :showTitle = "false"
                    :defaultValue = "selectedSubregion"
                />
            </div>

        </b-collapse> -->
        <div class="container">
        <div class="spacer" style="height:30px"></div>
        <Heading 
                :heading = "'Blog Posts'"
                :anchor = "'blogs'"
                :smaller="true"
            />

        <div class="columns is-multiline is-variable is-4-desktop" v-if="!isLoading">
            <PageResultColumns  
                v-for="(page, idx) in this.resultPages"
                v-bind:key = idx 
                :page = "page"
                :approveMode = "false"
                :showYear="true"
            />
        </div>
        
    <div class="section card" ref="results" v-if="isLoading">
        <b-icon class="fas fa-spinner fa-spin"></b-icon>
        Loading...
    </div>
    <div class="section card" ref="results" v-if="!isLoading && resultPages.length == 0">
        <!-- <b-icon class="fas fa-spinner fa-spin"></b-icon> -->
        None yet :(  You can <router-link to="/add">submit a blog post</router-link> to start filling this section.
    </div>
    
    <div class="spacer" style="height:60px"></div>

    <b-button type="is-primary is-large" style="margin-bottom:10px" v-if="!noMorePages && resultPages.length > 0" @click="nextPage" v-scroll-to="{
            el:'#result-last',
            easing:'ease',
            offset: -100
        
    }">Load more</b-button>
    <!-- <div v-if="activeFilterCount > 0" style="padding: 30px 0px; font-size: 18px; text-align:left">To see more results, <a v-on:click="clearFilters">click here to clear filters</a></div> -->
    <b-button v-if="resultPages.length > 0" v-scroll-to="'#app'" class="is-large">Scroll to top</b-button>

    <div class="popular-routes" v-if="routesByState.length > 0">
        <div class="spacer" style="height:80px"></div>
        <div class="divider"></div>
        <div class="spacer" style="height:80px"></div>


        <Heading 
            :anchor="'routes'"
            :preheading = "'Bikepacking & Touring'"
            :heading = "'Routes in ' + $maybeThe(selectedSubregion) + ' ' + selectedSubregion"
        />

        <!-- <h3 class='title is-size-2 is-size-3-mobile'  >{{$titleCase('Popular Routes in' + country_name + ' Routes')}}</h3>
        <div class="spacer" style="height:50px"></div> -->

        <div v-if="routesByState.length > 0">
            <ul >
                <li  class="list-link" v-for="routeObj in routesByState" v-bind:key="routeObj.display_name" >
                    <RouteRow  
                        v-bind:routeObj = "routeObj"
                    />
                </li>
            </ul>
        </div>
        <router-link to="/routes/" class="button is-size-4 is-size-5-mobile is-info" style="margin-top:10px;">See all routes</router-link>
        
    </div>
    <div class="spacer" style="height:60px"></div>


     <div class="books" v-if="booksByCountry.length > 0">
        <div class="spacer" style="height:80px"></div>
        <div class="divider"></div>
        <div class="spacer" style="height:80px"></div>
        
        <!-- <h3 class='title is-size-2 is-size-3-mobile' style="margin-bottom:5px" >Books About Bike Travel in {{$maybeThe(country_name)}} {{country_name}}</h3> -->

        <Heading 
            :anchor="'books'"
            :heading = "'Books'"
            :subheading = "'About Bike Travel in' + ($maybeThe(country_name).toLowerCase() == 'the' ? ' ' : '') + $maybeThe(country_name) + ' ' + country_name"
        />
        <!-- <span class='title is-size-5 is-size-6-mobile' style="margin-top:0px !important; text-transform:uppercase">{{this.country_name}}</span> -->
        <div class="spacer" style="height:50px"></div>

        <div class="columns is-multiline is-variable is-3-desktop" v-if="!isLoading">
        <Book  
            v-for="book in booksByCountry"
            v-bind:key = book.id
            :bookObj="book"
            />
        </div>
        <router-link to="/books/" class="button is-size-4 is-size-5-mobile is-info" style="margin-top:10px;">See all books</router-link>
        <div class="spacer" style="height:30px"></div>
        <p class="is-size-7 is-size-7-mobile">Some book links are affiliate links, which means BikeSleepBike may earn a small commission at no extra cost to you if you buy something through them.
                The money helps pay for hosting and infrastructure costs of running this website. As an Amazon Associate I earn from qualifying purchases. Thanks!

            </p>
    </div>
    <div class="spacer" style="height:100px"></div>


        </div>
    </div>
</template>

<script>
import PageResultColumns from '@/components/PageResultColumns';
// import PageResult from '@/components/PageResult';
// import ContinentFilter from '@/components/ContinentFilter';
import Heading from '@/components/Heading';
import RouteRow from '@/components/RouteRow';
import RadioFilter from '@/components/RadioFilter';
import Breadcrumb from '@/components/Breadcrumb';
import Book from '@/components/Book';
import TOC from '@/components/TOC';
export default {
  name: 'Country',
  components: {PageResultColumns, Heading, RouteRow, RadioFilter, Breadcrumb, Book, TOC},
  props: ['state'],
//   props: ['style_name'],
  data () {
    return {
        country_name: "United States",
        country_code: "US",
        // subregions: [],
        selectedSubregion: this.$titleCase(this.state),
        isLoading: false,
        noMorePages: false,
        lastVisibleResult: undefined,
        currentQuery: undefined,
        queryLimit: 21,
        resultPages: [],
        // selectedContinent: "",
        routesByState: [],
        booksByCountry: [],
        postCount: ''
        // styleMap: {'bike paths': 'bikepath', 'pavement': 'road'} // mapping from tag at page/post level to the bool associated with the route
    //    ridertags: ['solo female', 'solo', 'solo male', 'couple', 'fat bikes', 'over 65', 'diversify outdoors', 'LGBTQ+']
    }
  },
  computed: {
  
  },
  methods: {
    //   updateSelectedContinent(continent) {
    //       this.selectedContinent = continent;
    //       console.log("NEW CONT " + continent);
    //       var queryparts = this.translateStyleToQuery();
    //       if (this.selectedContinent == "All") {
    //         this.fetchPages(queryparts[0], queryparts[1], queryparts[2]);
    //       } else {
    //         this.fetchPagesByContinent(queryparts[0], queryparts[1], queryparts[2], this.selectedContinent);
    //       }
    //   },
      fetchPages(fieldname, querytype, value, subregion) {
            if (this.$debug) {console.log("DEBUG: In function fetchPages");}
            
            if (value != "") { // GET FILTERED
                this.$analytics.logEvent('fetch_results', { type: 'style', value: value});
                this.isLoading = true;
                var that = this;
                var result = [];
                this.noMorePages = false;
                this.lastVisibleResult = undefined;
                if (subregion && subregion != "All") {
                    // console.log(subregion);
                    this.currentQuery = this.$db.collection("pages").where("regions", "array-contains", subregion).orderBy("year", "desc").orderBy("added", "desc");
                } else {
                    this.currentQuery = this.$db.collection("pages").where(fieldname, querytype, value).orderBy("year", "desc").orderBy("added", "desc");
                }
                
                this.currentQuery.limit(that.queryLimit).get()
                    .then(function(querySnapshot) {
                        querySnapshot.forEach(function(doc) {
                            // doc.data() is never undefined for query doc snapshots
                            var dataAndId = doc.data();
                            
                            dataAndId.id = doc.id;
                            // console.log(dataAndId);
                            result.push(dataAndId);
                        
                        });
                        that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                        if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                            that.noMorePages = true;
                        }
                        that.resultPages = result;
                        that.isLoading = false;
                    })
                    .catch(function(error) {
                        console.log("Error getting pages: ", fieldname, querytype, value, subregion, error);
                        that.isLoading = false;
                    });
            } 
        },
        // updateSelectedSubregion(subregion) {
        //     this.selectedSubregion = subregion;
        //     // console.log(subregion);
        //     this.fetchPages("countries", "array-contains", this.country_code, this.selectedSubregion);
        //     // console.log(this.$route.params);
        //     // this.$route.params['subregion'] = this.selectedSubregion;
        //     // history.pushState(
        //     //     {},
        //     //     null,
        //     //     this.$route.path + '/' + encodeURIComponent(this.selectedSubregion)
        //     // );
        //     // console.log(this.$route.params);
        //     // if (this.$router.params.hasOwnProperty("subregion")) {

        //     // }
        //     // this.$router.replace({ params: {country: this.$countrymap[this.country_code], subregion: this.selectedSubregion}} );
        // },
        
        nextPage() {
            if (this.$debug) {console.log("DEBUG: In function nextPage");}
            var that = this;
            var result = [];  
            // var queryLimit = this.pageSize;
            //     if (this.activeFilterCount > 0) { //override pagination if filters are being used (hack for now because firebase sucks at tag filtering)
            //         queryLimit = 1000;
            //     }
            if (this.lastVisibleResult) {
                this.noMorePages = false;
                this.currentQuery.startAfter(this.lastVisibleResult).limit(that.queryLimit).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        // console.log(doc.id, " => ", doc.data());
                        // result.push(doc.data());
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    
                    });
                    // console.log("last");
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    that.resultPages.push(...result);
                    // that.resultPages = [].concat(that.resultPages, result); // this is for loading more below
                    // that.resultPages = result; // this is for replacing results with next page
                    // that.showingSelected = false;
                    // console.log(that.$route.path);
                    // if (that.$route.path != '/d') {
                    //     that.$router.push({ path: '/d'});
                    // }
                })
                .catch(function(error) {
                    console.log("Error getting next chunk of page results: ", error);
                });         

            } else {
                this.noMorePages = true;
            }
                  
           
        },
        getRoutesByState() {
            console.log("Getting route data for state " + this.selectedSubregion);
            this.routesByState = [];
            // var result = [];
            var that = this;
            var pageCountData = {};
            var routesMetadata = [];
            // first get routes page counts
            this.$db.collection("page_counts").doc('routes').get()
            .then(function(doc) {
                if (doc.exists) {
                    var temp = {};
                    temp[doc.id] = doc.data();
                    pageCountData = temp.routes;
                    // then get routes metadata
                    // var style = that.style_name;
                    // if (style == "bike paths") {
                    //     style = "bikepath";
                    // }
                    
                    that.$db.collection("routes").where('us_states', "array-contains", that.selectedSubregion).get().then((querySnapshot) => {
                        // console.log("looking for routes for country " + that.country_code);
                        querySnapshot.forEach((doc) => {
                            // doc.data() is never undefined for query doc snapshots
                            // var temp2 = {};
                            // temp2[doc.id] = doc.data();
                            // if (doc.data().countries.length <= 4) { // ONLY if this route includes two or fewer countries (to avoid showing the really long-haul routes at top)
                                routesMetadata.push(doc.data());
                            // }
                            // console.log(routesMetadata);
                        });

                        // then merge the two
                        for (var i = 0; i < routesMetadata.length; i++) {
                            var displayName = routesMetadata[i].display_name;
                            if (displayName in pageCountData) {
                                var newobj = routesMetadata[i];
                                newobj.post_count = pageCountData[displayName].post_count;
                                that.routesByState.push(newobj);
                            }
                        }
                        // console.log(that.routesData);
                        that.routesByState.sort((a, b) => (a.post_count > b.post_count) ? -1 : 1);
                    });
                } else {
                    console.log("ERROR: Can't fetch routes by state", that.selectedSubregion);
                }

            })
            .catch(function(error) {
                console.log("Error getting routes by country: ", error);
            });
            

        },
       fetchBooksByCountry(countrycode) {
            if (this.$debug) {console.log("DEBUG: In function fetchBooksByCountry");}
        
        // if (value != "") { // GET FILTERED
            this.$analytics.logEvent('fetch_results', { type: 'books by country', value: countrycode});
            var that = this;
            var result = [];
           
            this.$db.collection("books").where('countries', 'array-contains', countrycode).orderBy("title", "asc").limit(8).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    
                    });
                   
                    that.booksByCountry = result;
                    console.log(that.booksByCountry);
                    // that.isLoading = false;
                })
                .catch(function(error) {
                    console.log("Error getting books by country: ", error);
                    // that.isLoading = false;
                });
        // } 
        },
    //     getCount(state) {
    //         var that = this;
    //         this.$db.collection("page_counts").doc('countries').get()
    //         .then(function(doc) {
                
    //             if (doc.exists) {
    //                 // console.log(doc.data()[countrycode]['post_count'].toString());
    //                 // console.log(doc.data());
    //                 that.postCount = doc.data()[countrycode]['post_count'].toString();
    //             } else {
    //                 console.log("ERROR: Can't fetch route post count", countrycode);
    //                 that.postCount = '';
    //             }

    //         })
    //         .catch(function(error) {
    //             console.log("Error Can't fetch route post count ", error);
    //             that.postCount = '';
    //         });
    //     // }
            
    //   },
    

  },
  metaInfo() {
        var title =  this.$titleCase(this.selectedSubregion) + " - " + " Bikepacking & Touring";
        var description = "Blog posts, trip journals, routes, and other essential information about bike touring and bikepacking in " + this.$titleCase(this.selectedSubregion) + ".";
        return {
            title: title,
            titleTemplate: this.$titleTemplate,           
            description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com" + this.$route.path}
            ]
            // title: 'Browse | Bike Sleep Bike',
            // description: "Find bike travel blogs"
            
        }
    },
  mounted() {
    // this.country_name = this.$route.params.country;
    // var queryparts = this.translateStyleToQuery();
    // this.country_code = this.$getCodeFromCountry(this.country_name);
    this.fetchPages("countries", "array-contains", this.country_code, this.selectedSubregion);
    this.getRoutesByState();
    // this.getCount(this.selectedSubregion); // not aggregated yet
    this.fetchBooksByCountry(this.country_code);
    // console.log(this.country_code);
    var that = this;
    // this.$db.collection("regions").doc(that.country_code).get()
    //     .then(function(doc) {
    //         if (doc.exists) {
    //             var regions = doc.data().regions;
               
    //             that.subregions = regions.sort();
    //         }
    //     });


     
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  

</style>

<style>
    .page-results {
        max-width: 1500px;
        margin-left: auto;
        margin-right: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/State.vue